export default {
  github: {
    clientId: 'Ov23lidWw7sBjRZRuDof',
    workerUrl: 'https://github-oauth-proxy.a-herz.workers.dev',
    scope: 'repo'
  },
  repository: {
    owner: 'freegroup',
    repo: 'CampingElectricCalculator',
    defaultBranch: 'master'
  }
}
